import React from "react"
import Modal from "@kit/design/modal"
import Button from "@kit/design/button"
import { useListSnippets } from "sdk/snippets/queries"

const SnippetModal = ({ isOpen, setModal, insertSnippet }) => {
  const { data } = useListSnippets()
  const snippets = data?.snippets || []

  if (isOpen && !snippets.length) {
    return (
      <Modal label="Snippets" onClose={() => setModal(false)}>
        <div className="px-8 py-12 border-t border-gray-200 border flex text-gray-700 rounded">
          <p className="">
            Create reusable blocks of content that you can use in any broadcast
            or sequence email. You can create these snippets from your{" "}
            <a href="/account/snippets" className="underline">
              account settings.
            </a>
          </p>
        </div>
      </Modal>
    )
  }

  return (
    <>
      {isOpen && (
        <Modal label="Snippets" onClose={() => setModal(false)}>
          <p className="py-5 text-gray-800 border-t border-gray-200">
            Create reusable blocks of content that you can use in any broadcast
            or sequence email. You can create these snippets from your{" "}
            <a href="/account/snippets" className="underline">
              account settings.
            </a>
          </p>
          <div className="liquid-modal">
            {snippets.map((snippet, index) => {
              return (
                <div
                  key={index}
                  className="border p-4 rounded flex flex-col justify-between items-start"
                >
                  <h3 className="text-gray-800 font-semibold mb-2">
                    {snippet.label}
                  </h3>
                  <Button
                    className="text-blue-500 font-semibold mt-3 uppercase flex items-center"
                    onClick={() => {
                      setModal(false)
                      insertSnippet(snippet.insert_code)
                    }}
                    icon="plus-circle"
                  >
                    Add to email
                  </Button>
                </div>
              )
            })}
          </div>
        </Modal>
      )}
    </>
  )
}

export default SnippetModal
